import React from 'react';
import { TextField } from '@mui/material';

export default function ReasoningParserField({ value, onChange, disabled = false }) {
  return (
    <TextField
      label='Reasoning Parser (override)'
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      disabled={disabled}
    />
  );
}

